module.exports = __webpack_public_path__ + "img/GreekTechToxotaiS_ua.c55c63ef.webp";